import { ReceivedQuestion } from './ReceivedQuestion';
import {Voter} from "./Voter";
import {Assessor} from "./Assessor";

export class ReceivedPoll {
  active: boolean;
  assessors: number;
  bc: boolean;
  deleted: boolean;
  description: string;
  endDate: string;
  hasBeenClosed: boolean;
  hotline: boolean;
  uuid: string;
  is2FA: boolean;
  isLive: boolean;
  name: string;
  nbVoters: number;
  opened: boolean;
  publicVote: boolean;
  round: number;
  numberOfVote: number;
  shareResults: boolean;
  short_name: string;
  smsOption: boolean;
  startDate: string;
  creationDate: string;
  colleges: Array<ReceivedCollege>;
  type: string;
  userid: string;
  voters: number;
  votes: number;
  rounds: Array<Round>;
  sender: string;
  sharedLinks: string;
  forceBlankVote: boolean;
  quorum: number;
  attendance: number;
  welcomeText: string;
  ignoreAbstentions: boolean;
  image: string;
  assessorObjects: Array<Assessor>;
  assessorTest: AssessorTestResult;
  pollPlanningStatus: string;
}

export class ReceivedCollege {
  college: string;
  name: string;
  content: string;
  displayName: string;
}

export class AssessorTestResult {
  voters: number;
  votedVoters: number;
  remainingVoters: number;
  constructor(voters: number, votedVoters: number, remainingVoters: number) {
    this.voters = voters;
    this.votedVoters = votedVoters;
    this.remainingVoters = remainingVoters;
  }
}

export class CloningPoll {
  assessors: Array<Assessor>;
  bc: boolean;
  description: string;
  endDate: string;
  hasBeenClosed: boolean;
  hotline: boolean;
  uuid: string;
  is2FA: boolean;
  isLive: boolean;
  name: string;
  image: string;
  nbVoters: number;
  opened: boolean;
  publicVote: boolean;
  round: number;
  numberOfVote: number;
  shareResults: boolean;
  short_name: string;
  smsOption: boolean;
  startDate: string;
  type: string;
  userid: string;
  quorum: number;
  password: string;
  phoneChangeable: boolean;
  voters: Array<Voter>;
  rounds: Array<Round>;
  sender: string;
  sharedLinks: string;
  welcomeText: string;
}

export class Round {
  bc: boolean;
  displayedQuestions?: Array<ReceivedQuestion>;
  questions: Array<ReceivedQuestion>;
  results: string;
  round: number;
  title: string;
  votes: number;
  voters: number;
  closedAt: string;
  openedAt: string;
  cseResults: ElectionResults;
  seats: number;
  college: number;
  mainElection: boolean;
  testResults: string;
}

export class ElectionResults {
  start: string;
  end: string;
  assessors: Array<any>;
  votersCount: number;
  votesCount: number;
  nullVotes: number;
  candidatesWithResults: Array<CseRoundResult>;
  quotients: Array<Array<number>>;
}

export class CseRoundResult {
  candidate: string;
  list: string;
  listKey: number;
  sex: string;
  votes: number;
  listVotes: number;
  isElected: boolean;
  quotient: number;
}
